"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorMessages = void 0;
exports.errorMessages = {
    accountExists: 'An account is already registered with this email address. Please try again or login using this email.',
    invalidCredentials: 'The username and/or password you have entered is not recognised. Please try again.'
};
